module.exports = __webpack_public_path__ + "images/pages/lp/user_4_9e790cbc48310a86e734d0334ed36dd8.png";